<script>
  import { DialogHideScroll } from '@/mixins/dialogHideScroll';

  export default {
    name: 'DialogGame',

    mixins: [DialogHideScroll],

    data: () => ({
      title: '',
      subTitle: '',
      text: '',
      url: null,
      isTrailer: false,
      showPopup: false,
      callback: () => {},
    }),

    computed: {
      frameDialog() {
        return this.$store.getters['getIFrameDialog'];
      },
    },

    watch: {
      frameDialog() {
        this.showPopup = !!this.frameDialog;

        if (!this.frameDialog) {
          this.clearData();
          return;
        }

        this.setTopIndexToWindow();

        const { text, title, url, isTrailer, callback } = this.frameDialog;

        this.text = text;
        this.title = title;

        // Prevent double request for the same url
        this.$nextTick(() => {
          this.url = url;
        });

        this.isTrailer = isTrailer;
        this.callback =
          callback ||
          (() => {
            this.$store.dispatch('hideIFrameDialog', null);
          });
      },
    },

    methods: {
      clearData() {
        this.title = '';
        this.subTitle = '';
        this.text = '';
        this.url = null;
        this.isTrailer = false;
        this.callback = () => {};
      },
      setTopIndexToWindow() {
        setTimeout(() => {
          const dialogContainer = document.querySelector('#game-container');
          const dialogParent = dialogContainer?.parentElement?.parentElement;

          if (dialogContainer && dialogParent) {
            dialogParent.style.zIndex = 999999;
          }
        }, 0);
      },
      setupMessageListener() {
        window.addEventListener('message', this.handleMessage);
      },
      handleMessage(event) {
        if (event.data && event.data.type === 'openAddFriendsDialog') {
          this.$store.dispatch('showIFrameAddFriendsDialog', { url: event.data.url });
        }
      },
    },

    beforeDestroy() {
      window.removeEventListener('message', this.handleMessage);
    },
  };
</script>

<template>
  <v-dialog
    v-if="showPopup"
    v-model="showPopup"
    :content-class="`${isTrailer ? 'yt-trailer' : 'game-dialog'} black`"
    :scrollable="false"
    fullscreen
    persistent
    width="100%"
  >
    <div id="game-container">
      <iframe
        v-if="showPopup"
        id="dialogFrameId"
        :name="`${isTrailer ? '' : 'gameUrlFrame'}`"
        :src="url"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        frameborder="0"
        height="100%"
        width="100%"
        @load="setupMessageListener"
      />
      <v-btn class="close-btn-modal" color="primary" text @click="callback()">x</v-btn>
    </div>
  </v-dialog>
</template>

<style lang="scss" scoped>
  #game-container {
    width: 100%;
    height: 100%;
  }

  .close-btn-modal {
    top: 10px;
    right: 10px;
  }
</style>
